import * as d3 from 'd3-selection'
import text from './text.js'
import behind from './behind.js'
import endLine from './endline.js'
import _defs from './defs.js'

export default function (selection, defs, gantt) {
  selection.each(function (d) {
    var container = d3.select(this)
      , dim = gantt.dimensions.node[d._gantt.hasChildren ? 'withChildren' : 'withoutChildren']
      , height = gantt.tree.options.height - dim.margin.top - dim.margin.bottom
    // First set up the defs
    defs.call(_defs, gantt.id, gantt.xScale, dim.margin.top, height, gantt.tree, dim.tipHeight)

    // Then draw the extension drawing if it exists
    var extension = container.selectAll('use.gantt-item-descendant-extension')
                             .data(defs.select('path.gantt-item-descendant-extension-path').data())

    extension.enter()
             .insert('use', ':first-child')
             .attr('class', 'gantt-item-descendant-extension')
             .merge(extension)
             .attr('xlink:href', d => `#gantt-${gantt.id}-item-descendant-extension-${d.id}`)
             .attr('clip-path', `url(#gantt-${gantt.id}-item-descendant-extension-clip-path-${d.id})`)

    extension.exit()
             .remove()

    // Add a group that will contain the two drawings. This group is going to have a clipPath that
    // is the shape. This allows us to double the stroke-width, and chop off half of it using a clip path
    // This way the endLine hits the borders of the visible stroke
    var group = container.selectAll('g.main-shape')
                         .data(d => [d])
                         .enter()
                           .append('g')
                           .merge(container.selectAll('g.main-shape'))
                           .attr('class', 'main-shape')
                           .attr('clip-path', `url(#gantt-${gantt.id}-item-clip-path-${d.id})`)
      , use = group.selectAll('use') // Then the `use` elements
                   .data(d => [{
                     id: d.id,
                     clazz: 'gantt-item-task-background'
                   }, {
                     id: d.id,
                     clipPath: `url(#gantt-${gantt.id}-item-status-clip-path-${d.id})`,
                     clazz: `gantt-item-task-foreground`
                   }])

    use.exit().remove()

    use.enter()
       .append('use')
         .attr('class', d => `${d.clazz}`)
         .merge(use)
         .attr('xlink:href', d => `#gantt-${gantt.id}-item-task-path-${d.id}`)
         .attr('clip-path', d => d.clipPath)

    group.call(text, dim) // Add the text status on top of the drawing
         .call(behind, dim) // Then a potential behind indicator
         .call(endLine, gantt.id, gantt.tree) // Then the end line uses when the foreground shape is smaller than the full shape
  })
}
